import React, { useRef, useEffect, useState } from 'react'
import { TIPOLOGIE } from '.'
import { useDispatch, useApiCallback, setData, useSelector } from 'gf-ui'
import { useNavigate } from 'react-router-dom'
import apiQuestionario from '../api/apiQuestionario'
import { HomeSenologia } from './senologia'
import { HomeColon } from './coloneRetto'
import HomeTicketPsStranieri from './ticketPsStranieri/HomeTicketPsStranieri'
import PageContainer from '../components/PageContainer'


const HomeQuestionario = ({ tipologia }) => {
  const pageData = useSelector(state => state.page.data)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const apiCallback = useApiCallback()
  const _apiQuestionario = useRef(new apiQuestionario(dispatch, apiCallback, null))
  _apiQuestionario.current.setFixedParams({ ID_TIPOLOGIA: tipologia.KID })
  const shouldInit = useRef(true)
  const [initialized, setInitialized] = useState(false)

  useEffect(() => {
    if (shouldInit.current) {
      shouldInit.current = false
      setInitialized(false)
      _apiQuestionario.current.fnInit((res) => {
        setData(dispatch, { 
          ...pageData, 
          datiAziendali: JSON.parse(res.datiAziendali), 
          tipoLayout: res.tipoLayout, 
          LINGUA: 'it' 
        })
        setInitialized(true)
      }, () => navigate("/"))
    }
  }, [dispatch, initialized, navigate, pageData])

  return initialized && <PageContainer tipologia={tipologia}>
      {tipologia.KID === TIPOLOGIE.SENOLOGIA.KID && <HomeSenologia tipologia={tipologia} />}
      {tipologia.KID === TIPOLOGIE.COLON_RETTO.KID && <HomeColon tipologia={tipologia} />}
      {tipologia.KID === TIPOLOGIE.TICKET_PS_STRANIERI.KID && <HomeTicketPsStranieri tipologia={tipologia} />}      
    </PageContainer>  
}

export default HomeQuestionario;